import type {PaymentMethod as TPaymentMethod} from 'coreStore/data/basket/types';
import ApplePayPaymentMethod from './paymentMethods/ApplePayPaymentMethod';
import GooglePayPaymentMethod from './paymentMethods/GooglePayPaymentMethod';
import PaymentMethod from './paymentMethods/PaymentMethod';

/**
 * Represents PaymentMethodsFactory
 */
class PaymentMethodsFactory {
	/**
	 * Returns payment method
	 * @param {String} paymentMethodID - payment method ID
	 * @param {TPaymentMethod} paymentMethodObject - object with payment method data
	 * @returns {PaymentMethod} - payment method
	 */
	public static create(paymentMethodID: string, paymentMethodObject: TPaymentMethod): PaymentMethod {
		switch (paymentMethodID) {
			case 'apmgw_GooglePay':
				return new GooglePayPaymentMethod(paymentMethodObject);
			case 'DW_APPLE_PAY':
				return new ApplePayPaymentMethod(paymentMethodObject);
			default:
				return new PaymentMethod(paymentMethodObject);
		}
	}
}

export default PaymentMethodsFactory;
